import { render, staticRenderFns } from "./gaji.vue?vue&type=template&id=7205cd97"
import script from "./gaji.vue?vue&type=script&lang=js"
export * from "./gaji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports